import { useContext } from 'react';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';

import { setStep } from '~/src/features/tariffBuilder/actions';
import { constructorAnalytics } from '~/src/features/tariffBuilder/analytics';
import { constructorCurrentTariffAnalytics } from '~/src/features/tariffBuilder/analytics';
import DecodersBlock from '~/src/features/tariffBuilder/components/DecodersBlock';
import RoutersBlock from '~/src/features/tariffBuilder/components/RoutersBlock';
import Section from '~/src/features/tariffBuilder/components/Section';
import MovixNotSelected from '~/src/features/tariffBuilder/components/toast/MovixNotSelected';
import { Ctx } from '~/src/features/tariffBuilder/Ctx';
import { useCtxDispatch, useCtxSelector } from '~/src/features/tariffBuilder/hooks';
import getDecoders from '~/src/features/tariffBuilder/selectors/getDecoders';
import isBaseTvSelected from '~/src/features/tariffBuilder/selectors/isBaseTvSelected';
import selectCurrentTariff from '~/src/features/tariffBuilder/selectors/selectCurrentTariff';
import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';
import { ESteps } from '~/src/features/tariffBuilder/types/ESteps';
import { TCurrentTariff } from '~/src/features/tariffBuilder/types/TCurrentTariff';

const getActionBtnText = (currentTariff?: TCurrentTariff): string => {
    if (!currentTariff) {
        return 'Перейти к оформлению';
    }
    return 'Перейти к оформлению тарифа';
};

const Equipment = (): JSX.Element => {
    const dispatch = useCtxDispatch();

    const { hasSmartTv, hasDecoder, isTvSelected, speed, currentTariff } = useCtxSelector(state => {
        return {
            hasSmartTv: state.hasSmartTv,
            hasDecoder: getDecoders(state).some(el => el.isSelected),
            isTvSelected: isBaseTvSelected(state),
            speed: state[EEntity.speed][state.selectedSpeed].speed,
            currentTariff: selectCurrentTariff(state),
        };
    });
    const { toaster } = useContext(Ctx);

    const handleButtonClick = () => {
        if (isTvSelected && !(hasSmartTv || hasDecoder)) {
            toaster.add(<MovixNotSelected/>);
            return;
        }

        if (currentTariff) {
            dispatch(setStep(ESteps.FillContacts));
            constructorCurrentTariffAnalytics.clickedMoveToChangeTariff();

        } else {
            constructorAnalytics.clickedMoveToFullbuyForm();
            dispatch(setStep(ESteps.FillAddress));
        }
    };

    return (
        <>
            <Section>
                <RoutersBlock speed={speed}/>
            </Section>

            {isTvSelected && (
                <Section>
                    <DecodersBlock/>
                </Section>
            )}
            <ButtonGroup>
                <Button
                    bType={'action'}
                    onClick={handleButtonClick}
                >
                    {getActionBtnText(currentTariff)}
                </Button>
            </ButtonGroup>
        </>
    );
};

export default Equipment;
